import { r as registerPlugin } from '../common/index-67482630.js';
import '../common/_polyfill-node:global-acbc543a.js';

const SplashScreen = registerPlugin('SplashScreen', {
    web: () => import('../common/web-5123d1be.js').then(m => new m.SplashScreenWeb()),
});

export { SplashScreen };
